import React from "react";

// Components
import DatabaseTables from "./DatabaseTables";
import { getAmortizationV2TableDataAction, getDailyOperationsV2DataAction, getEmiRecieptsTableDataAction, getLoanApplicationDataTable, getLoanProcessTableData, getReceiptTableDataAction } from "./DatabaseTableAction";
import { OPERATION_STATUS } from "../../config/axios.init";
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";

class DatabaseTablesContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoadingModal: false,
            errorMessage: "",
            loanProcessTableData: [],
            loanApplicationTableData: [],
            dailyOperationsV2TableData: [],
            amortizationV2TableData: [],
            receiptTableData: [],
            emiRecieptTableData: []
        }

    }
showLoadingModal = () => {
        this.setState({
            showLoadingModal: true
        })
    }

    closeLoadingModal = () => {
        this.setState({
            showLoadingModal: false
        })
    }
    getLoanApplicationTableData = (request) => {
        this.showLoadingModal();
        getLoanApplicationDataTable(request, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.closeLoadingModal();
                this.setState({
                    errorMessage: "",
                    loanApplicationTableData: response.data.data
                });
            } else {
                this.closeLoadingModal();
                this.setState({
                    errorMessage: response.data.message
                });
            }
        })
    }

    getLoanProcessTableData = (request) => {
        this.showLoadingModal();
        getLoanProcessTableData(request, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.closeLoadingModal();
                this.setState({
                    errorMessage: "",
                    loanProcessTableData: response.data.data
                });
            } else {
                this.closeLoadingModal();
                this.setState({
                    errorMessage: response.data.message
                });
            }
        })
    }

    getDailyOperationsV2TableData = (request) => {
        this.showLoadingModal();
        getDailyOperationsV2DataAction(request, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.closeLoadingModal();
                this.setState({
                    errorMessage: "",
                    dailyOperationsV2TableData: response.data.data
                });
            } else {
                this.closeLoadingModal();
                this.setState({
                    errorMessage: response.data.message
                });
            }
        })
    }
    getAmortizationV2TableData = (request) => {
        this.showLoadingModal();
        getAmortizationV2TableDataAction(request, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.closeLoadingModal();
                this.setState({
                    errorMessage: "",
                    amortizationV2TableData: response.data.data
                });
            } else {
                this.closeLoadingModal();
                this.setState({
                    errorMessage: response.data.message
                });
            }
        })
    }

    getEmiRecieptsTableData = (request) => {
        this.showLoadingModal();
        getEmiRecieptsTableDataAction(request, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.closeLoadingModal();
                this.setState({
                    errorMessage: "",
                    emiRecieptTableData: response.data.data
                });
            } else {
                this.closeLoadingModal();
                this.setState({
                    errorMessage: response.data.message
                });
            }
        })
    }

    getReceiptTableData = (request) => {
        this.showLoadingModal();
        getReceiptTableDataAction(request, (response) => {
            if (response.status === OPERATION_STATUS.SUCCESS) {
                this.closeLoadingModal();
                this.setState({
                    errorMessage: "",
                    receiptTableData: response.data.data
                });
            } else {
                this.closeLoadingModal();
                this.setState({
                    errorMessage: response.data.message
                });
            }
        })
    }
    resetTableData = () => {
        this.setState({
            loanProcessTableData: [],
            loanApplicationTableData: [],
            dailyOperationsV2TableData: [],
            amortizationV2TableData: [],
            receiptTableData: [],
            emiRecieptTableData: []
        })
    }
    render() {
        return (
            <>
                <LoadingModal
                    showLoadingModal={this.state.showLoadingModal}
                />
                <DatabaseTables
                    errorMessage={this.state.errorMessage}
                    getLoanApplicationDataTable={this.getLoanApplicationTableData}
                    getLoanProcessTableData={this.getLoanProcessTableData}
                    getDailyOperationsV2TableData={this.getDailyOperationsV2TableData}
                    getAmortizationV2TableData={this.getAmortizationV2TableData}
                    getEmiRecieptsTableData={this.getEmiRecieptsTableData}
                    getReceiptTableData={this.getReceiptTableData}
                    loanApplicationData={this.state.loanApplicationTableData}
                    loanProcessTableData={this.state.loanProcessTableData}
                    dailyOperationsV2TableData={this.state.dailyOperationsV2TableData}
                    amortizationV2TableData={this.state.amortizationV2TableData}
                    emiRecieptTableData={this.state.emiRecieptTableData}
                    receiptTableData={this.state.receiptTableData}
                    resetTableData={this.resetTableData}
                />
            </>
        )
    }

}

export default DatabaseTablesContainer;